import React from "react";
import { useNavigate } from "react-router-dom";

const SingleBrandProduct = ({ product }) => {
  const { _id, product_name, product_image, product_price } = product;
  const navigate = useNavigate();

  const handleBuyNow = () => {
    navigate(`/checkout/${_id}`);
  };

  return (
    <div className="card card-compact w-96 lg:w-100 bg-base-100 shadow-xl">
      <figure>
        <img src={product_image} alt="Shoes" style={{ height: "250px" }} />
      </figure>
      <div className="card-body">
        <h2 className="card-title text-primary">{product_name}</h2>
        <p className="text-xl badge badge-secondary py-5 px-3 text-white">
          Price : {product_price} Tk.
        </p>
        <div className="card-actions justify-end">
          <button className="btn btn-primary" onClick={handleBuyNow}>
            Buy Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default SingleBrandProduct;
